import { ITravelSumary } from "./ITravelSummary.model"
// TODO: apagar esse model
export interface IRoutesTravel {
  routes: [
    {
      id: string,
      sections: [
        {
          id: string,
          type: string,
          departure: {
            time: string,
            place: {
              type: string,
              location: {
                lat: number,
                lng: number
              },
              originalLocation: {
                lat: number,
                lng: number
              }
            }
          },
          arrival: {
            time: string,
            place: {
              type: string,
              location: {
                lat: number,
                lng: number
              },
              originalLocation: {
                lat: number,
                lng: number
              }
            }
          },
          travelSummary: ITravelSumary
          transport: {
            mode: string
          }
        }
      ]
    }
  ]
}
